import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import DashboardDrawCounter from 'components/dashboard/EntriesAndStats/DrawCounter';
import DrawCounter from 'components/home-page/DrawCounter';
import { DaymadeDesignSystemPreviewComponentInfo } from '.';

const ComponentPreview = () => {
  return (
    <AboutUsModule background="grey">
      <AboutUsSiteContainer>
        <h3 className="aboutUsTypographyHeaderLarge">Draw Countdown </h3>
        <p>
          <>
            The draw countdown component. It will take up the full width of its
            container, and is designed to be placed on a background of a
            different colour to the rest of the page.
          </>
        </p>
        <h4 className="aboutUsTypographyHeaderMedium">DrawCounter</h4>
        <div style={{ padding: 16, margin: 'auto' }}>
          <DrawCounter
            targetDate={new Date(new Date().getTime() + 1000 * 60 * 60 * 24)}
          />
        </div>
        <p>
          It can also appear in "bare" mode, so that it does not provide any
          padding, margin nor background. This allows the consumer to provide
          their own spacing and background colour
        </p>
        <div>
          <div
            style={{ background: 'pink', padding: 16, display: 'inline-block' }}
          >
            <DrawCounter
              targetDate={new Date(new Date().getTime() + 1000 * 60 * 60 * 24)}
              bare
            />
          </div>
        </div>
        <p>
          The introText can also be set to empty-string. Also note that the
          width of the block changes when in bare mode
        </p>
        <div>
          <div
            style={{ background: 'pink', padding: 0, display: 'inline-block' }}
          >
            <DrawCounter
              targetDate={new Date(new Date().getTime() + 1000 * 60 * 60 * 24)}
              bare
              introText=""
            />
          </div>
        </div>
        <div>
          <div
            style={{ background: 'pink', padding: 0, display: 'inline-block' }}
          >
            <DrawCounter
              targetDate={new Date(new Date().getTime() + 1000 * 60 * 60 * 12)}
              bare
              introText=""
            />
          </div>
        </div>
        <h4 className="aboutUsTypographyHeaderMedium">DashboardDrawCounter</h4>
        <p>
          This version of the counter is a separate component that looks
          different to fit in on the dashboard page
        </p>
        <div style={{ padding: 16, margin: 'auto' }}>
          <DashboardDrawCounter
            headingText="Your next draw is in"
            targetDate={new Date(new Date().getTime() + 1000 * 60 * 60 * 24)}
          />
        </div>
      </AboutUsSiteContainer>
    </AboutUsModule>
  );
};

ComponentPreview.daymadeDesignSystemInfo = {
  name: 'Draw Countdown',
} as DaymadeDesignSystemPreviewComponentInfo;

export default ComponentPreview;
